import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {FeedbackFormConstants} from '../../../../../shared/feedback_form/FeedbackFormConstants'
import {TimeUtils} from '@colonist/utils'
import {StorageWrapper} from '../../StorageWrapper'
import {UIAPIEndpoints} from '../../network/UIAPIEndpoints'
import {UIAjaxWrapper} from '../../network/UIAjaxWrapper'
import {ClientUserState} from '../../ClientUserState'

export class FeedbackFormUtils {
    static async fetchShouldShowFeedbackForm() {
        if(ClientUserState.userState == undefined) return

        if(!this.haveEnoughDaysPassedSinceLastFeedbackForm()) return

        const shouldShowFeedbackForm = StorageWrapper.getShouldShowFeedbackForm()
        if(shouldShowFeedbackForm != null) return

        const res = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFeedbackFormShow(), undefined)
        if(res == undefined) {
            StorageWrapper.setShouldShowFeedbackForm(false)
            return
        }

        const shouldShow = res.json as AjaxDataTypes.FeedbackFormShouldShowData

        StorageWrapper.setShouldShowFeedbackForm(shouldShow.shouldShow)
        if(shouldShow.lastShown != undefined) StorageWrapper.setLastFeedbackFormDate(shouldShow.lastShown)
    }

    static shouldShowFeedbackForm(): boolean {
        if(!this.haveEnoughDaysPassedSinceLastFeedbackForm()) return false

        const show = StorageWrapper.getShouldShowFeedbackForm()
        if(show == null) return false

        StorageWrapper.removeShouldShowFeedbackForm()
        return show
    }

    private static haveEnoughDaysPassedSinceLastFeedbackForm(): boolean {
        const lastFeedbackFormDate = StorageWrapper.getLastFeedbackFormDate()
        if(lastFeedbackFormDate != null) {
            const daysPassed = TimeUtils.absoluteDifferenceInDays(lastFeedbackFormDate, new Date())
            if(daysPassed < FeedbackFormConstants.DAYS_BETWEEN_FEEDBACK_FORMS) return false
        }
        return true
    }
}
